const React = require("react");
const PropTypes = require("prop-types");
const classNames = require("classnames");

class Button extends React.PureComponent {
  render() {
    const { disabled, primary, inverse, uppercase, children, onClick } =
      this.props;

    const className = classNames(
      "b-button",
      disabled && "b-button--disabled",
      !primary && "b-button--grey",
      inverse && "b-button--inverse",
    );

    return (
      <button
        disabled={disabled}
        onClick={onClick}
        type="button"
        className={className}
        style={{
          margin: 0,
          textTransform: uppercase ? "uppercase" : "none",
          letterSpacing: uppercase ? "0.05em" : "0",
          fontSize: 14,
          padding: "11px 24px",
        }}
      >
        {children}
      </button>
    );
  }
}

Button.propTypes = {
  disabled: PropTypes.bool,
  primary: PropTypes.bool,
  inverse: PropTypes.bool,
  uppercase: PropTypes.bool,
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  disabled: false,
  primary: false,
  inverse: false,
  uppercase: false,
  onClick: () => {},
};

module.exports = Button;
